// React
import React from 'react';
// Internal
import CustomTable from 'components/shared/molecules/CustomTable/CustomTable';
// Styles
import './styles.scss';
import HeaderDivider from 'components/shared/atoms/HeaderDivider/HeaderDivider';

/**
 * @param {string} props.data - The text to be display in the previous button
 * @param {string} props.headerTitle - The text to be display in the header of the table
 * @param {string} props.className - className to be applied to the component
 */
class ConfirmationTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className={`confirmation-table-container ${this.props.className ? this.props.className : ''}`}>
                <HeaderDivider title={this.props.headerTitle} />
                <CustomTable
                    className="confirmation-table"
                    data={this.props.data}
                    headers={[]}
                />
            </div>
        );
    }
}

export default ConfirmationTable;
